var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "aftersale-edit-dialog",
      attrs: {
        title: _vm.serviceNo,
        width: "30%",
        "append-to-body": true,
        visible: _vm.editDialogVisible
      },
      on: {
        "update:visible": function($event) {
          _vm.editDialogVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.goodsEditform } },
        [
          _c("el-form-item", { attrs: { label: "SKU:829030" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showInbound,
                  expression: "showInbound"
                }
              ],
              attrs: { label: "入库数量:", "label-width": "80px" }
            },
            [
              _c("el-input", {
                attrs: { autocomplete: "off" },
                model: {
                  value: _vm.goodsEditform.name,
                  callback: function($$v) {
                    _vm.$set(_vm.goodsEditform, "name", $$v)
                  },
                  expression: "goodsEditform.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showInbound,
                  expression: "!showInbound"
                }
              ],
              attrs: { label: "出库数量:", "label-width": "80px" }
            },
            [
              _c("el-input", {
                attrs: { autocomplete: "off" },
                model: {
                  value: _vm.goodsEditform.name,
                  callback: function($$v) {
                    _vm.$set(_vm.goodsEditform, "name", $$v)
                  },
                  expression: "goodsEditform.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showInbound,
                  expression: "!showInbound"
                }
              ],
              attrs: { label: "快递单号:", "label-width": "80px" }
            },
            [
              _c("el-input", {
                attrs: { autocomplete: "off" },
                model: {
                  value: _vm.goodsEditform.name,
                  callback: function($$v) {
                    _vm.$set(_vm.goodsEditform, "name", $$v)
                  },
                  expression: "goodsEditform.name"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.editDialogVisible = false
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.editDialogVisible = false
                }
              }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-042b1576", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-042b1576","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bigAftersale/aftersale-edit-dialog.vue
// module id = null
// module chunks = 